import { useIsBreakpoint } from './use-breakpoint'

export const useIsMobile = () => useIsBreakpoint('lg')
